import { Entity, collisionMover, WeaponCharacteristics } from "game-common/models"
import { ApplyInputResultPool } from "game-common/apply_input_result_pool"
import { TileMapMetaProvider } from "game-common/tile_map_meta_provider"

/** Advance local projectile playback. The caller owns removal or hiding until server removal. */
export function advanceProjectile(bullet: Entity, dt: number, map: TileMapMetaProvider): boolean {
    if (bullet.isDead()) return false
    if (dt <= 0) return true
    if (bullet.crossFloorProjectile) {
        bullet.location.x += bullet.speed2.x * dt
        bullet.location.y += bullet.speed2.y * dt
        return true
    }
    const result = ApplyInputResultPool.instance.checkout()
    try {
        bullet.applyInput(undefined, dt, bullet.speed2, result.data,
            collisionMover(map, false, false, bullet.spriteId === WeaponCharacteristics.bow.bulletSpriteId), true)
        return !!(result.data.movedX || result.data.movedY) &&
            !(bullet.maxDistance !== undefined && bullet.travelledDistance() > bullet.maxDistance)
    } finally { ApplyInputResultPool.instance.release(result) }
}
